import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes2";

import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
  textFieldClasses,
} from "@mui/material";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";

import "react-tabs/style/react-tabs.css";
import TablaPuc from "./modalTablaPuc";
import axios from "axios";
import moment from "moment";
import CatalogoCoordinacion from "../../catalogos/catalogoCoordinacion";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import useTableFijo from "../useTableFijo";
import useTableFijo2 from "../useTableFijo2";
import useTableFijo3 from "../useTableFijo3";
import { Dimmer } from "../spinner";
import { ActualizarProductoCompra } from "./modalActualizarProductoCompra";
import { ModalAgregarFactuOC } from "./modalAgregarFacturaOC";
import { AgregarCuentasGastos } from "../presupuesto/modalAgregarCuentasGastos";

export const ActualizarOrdenCompra = (props) => {
  /*  variables de estados */
  const permiso = JSON.parse(localStorage.getItem("accsolicompra"));
  const [idEfi] = useState(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const headCells = [
    {
      id: "id",
      label: "Codigo",
      width: "40px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "razonsocial",
      label: "Cantidad",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "concepto_producto",
      label: "Producto",
      width: "350px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "precio_unitario",
      label: "Precio Unitario",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "accion",
      label: "% IVA",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "monto_iva",
      label: "Monto IVA",
      width: "40px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "descuento",
      label: "Descuento",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "base_imponible",
      label: "Base Imponible",
      width: "350px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "total_iva",
      label: "Total con Iva",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
  ];

  const headCells2 = [
    {
      id: "id_factura",
      label: "N° Factura",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "num_control",
      label: "N° Control",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "fecha_factura",
      label: "Fecha Factura",
      width: "80px",
      textAlign: "right",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "sub_total",
      label: "Sub-Total",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "otros",
      label: "Otros",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "ajuste",
      label: "Ajustes",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "exento",
      label: "Exento",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "base_imponible",
      label: "Base Imponible",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "iva",
      label: "% IVA",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
    {
      id: "total",
      label: "Total",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "14px",
      color: "white",
    },
  ];

  const headCells3 = [
    {
      id: "1",
      label: "Cuentas Presupuestarias",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "12px",
      color: "white",
    },
    {
      id: "11",
      label: "Concepto",
      width: "350px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "12px",
      color: "white",
    },
    {
      id: "12",
      label: "Monto Precompromiso",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "12px",
      color: "white",
    },
    {
      id: "3",
      label: "Monto a Comprometer",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "12px",
      color: "white",
    },
  ];

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [mostrarAgregar, setMostrarAgregar] = useState(false);
  const [mostrarAgregarF, setMostrarAgregarF] = useState(false);
  const [mostrarAgregarC, setMostrarAgregarC] = useState(false);
  const btnCancela = useRef();
  const btnAcepta = useRef();
  //const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const [tipoProv, setTipoProv] = useState(0);
  const [itemSelectP, setItemSelectP] = useState(-1);
  const [itemSelectF, setItemSelectF] = useState(-1);
  const [itemSelectC, setItemSelectC] = useState(-1);
  const [operacionP, setOperacionP] = useState(0);
  const [operacionF, setOperacionF] = useState(0);
  const [operacionC, setOperacionC] = useState(0);
  const [producto, setProducto] = useState();
  const [factura, setFactura] = useState([]);
  const [proveExento, setProveExento] = useState(false);
  const [body, setBody] = useState(null);
  const radioCompra = useRef();
  const radioServicio = useRef();
  const txtConcepto = useRef();
  const txtObservaciones = useRef();
  const txtTiempoEntrega = useRef();
  const txtLugarEntrega = useRef();
  const radioContado = useRef();
  const radioCredito = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [declaWeb, setDeclaWeb] = useState();
  const [mensaje1, setMensaje1] = useState();
  const [total, setTotal] = useState(0.0);
  const [totaldescuento, setTotaldescuento] = useState(0.0);
  const [totalSinIva, setTotalSinIva] = useState(0.0);
  const [totalIva, setTotalIva] = useState(0.0);
  const [descuento, setDescuento] = useState(0.0);

  const [totalFactu, setTotalFactu] = useState(0.0);
  const [totalCuenta, setTotalCuenta] = useState(0.0);
  const [presupuesto, setPresupusto] = useState(0.0);
  const [disponibilidad, setDisponibilidad] = useState(0.0);

  const [tipoMensajes, setTipoMensajes] = useState(
    "Datos que Soportan la Orden de Compra",
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tabs, setTabs] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane",
    tab3: "tab-pane",
    tab4: "tab-pane",
    tab5: "tab-pane",
    btn: 1,
  });
  const txtDescrp = useRef();
  const txtProyecto = useRef();
  const txtRazonS = useRef();
  const txtDenominacion = useRef();

  const txtCedRif = useRef();
  const txtNomProv = useRef();
  const txtFechaC = useRef();
  const txtCapp = useRef();
  const txtCaps = useRef();
  const txtStatus = useRef();
  const txtFondter = useRef();
  const txtExentoIva = useRef();
  const txtFechaReg = useRef();
  const txtOficReg = useRef();
  const txtProtocolo = useRef();
  const txtRequisicion = useRef();
  const txtRqInforme = useRef();
  const txtInvitacion = useRef();
  const txtPresu = useRef();
  const txtTomo = useRef();
  const txtFolio = useRef();
  const txtNumReg = useRef();
  const txtPrecompromisoSi = useRef();
  const txtPrecompromisoNo = useRef();
  const txtRcomercio = useRef();
  const txtBgva = useRef();
  const txtTipocontri = useRef();
  const txtSrvnc = useRef();
  const txtCdRp = useRef();
  const txtCsun = useRef();
  const txtPislr = useRef();
  const txtRifAct = useRef();
  const txtSivss = useRef();
  const txtSinces = useRef();
  const txtSlab = useRef();
  const txtSmunip = useRef();
  const txtLcAct = useRef();
  const txtCodae = useRef();
  const txtBienesS = useRef();
  const txtContratista = useRef();
  const txtFondos = useRef();
  const txtIdProv = useRef();
  const txtCantiCarta = useRef();
  const txtCartaEx = useRef();
  const txtCantPresu = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const [operacionPer, setOperacionPer] = useState(0);
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbSexo = useRef();
  const cmbNacionalidad = useRef();
  const txtIdc = useRef();
  const txtCodigo = useRef();
  const txtDescrip = useRef();
  const [tecla, setTecla] = useState();
  const [visibleF, setVisibleF] = useState("collapse");
  const [visibleG, setVisibleG] = useState("collapse");
  const [visibleR, setVisibleR] = useState(0);
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [filterFn2, setFilterFn2] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [filterFn3, setFilterFn3] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [records, setRecords] = useState([]);
  const [records2, setRecords2] = useState([]);
  const [records3, setRecords3] = useState([]);

  const [coordinacion, setCoordinacion] = useState({
    idcoordinacion: "",
    nombre: "",
  });
  const [valuest, setValuest] = useState({
    idestado: "",
    idmunicipio: "",
    idciudad: "",
  });
  const [values, setValues] = useState({
    idordencompra: "",
    fecha: "",
    observaciones: "",
    tipo: "",
    concepto: "",
    escredito: "",
    numcontrol: "",
    monto: "",
    montoiva: "",
    idproveedor: "",
    idcordinacion: "",
    idusuario_crea: "",
    fecha_crea: "",
    fecha_reverso: "",
    idusuario_reversa: "",
    hora_crea: "",
    horareverso: "",
    reversado: "",
    motivo: "",
    reqrequisicion: "",
    reqinvitacion: "",
    reqinforme: "",
    cantpresupuesto: "",
    cantcarta: "",
    reqcarta: "",
    proyecto: "",
    descripcionproyecto: "",
    tentrega: "",
    observacion: "",
    idordenservicio: "",
    reqpresupuesto: "",
    iddatosresponsables: "",
    idprecompromiso: "",
    idprecompromisoaso: "",
    aprobada: "",
    unidades: "",
    iddatalcalde: "",
    iddatadmini: "",
  });

  const [status, setStatus] = useState();
  const [ciudad, setCiudad] = useState();
  const [municipio, setMunicipio] = useState();
  const [estado, setEstado] = useState();
  let punitario = 0.0;
  let cantidad = 0.0;
  let iva = 0.0;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn);

  const {
    TblContainer2,
    TblHead2,
    TblPagination2,
    recordsAfterPagingAndSorting2,
  } = useTableFijo2(records2, headCells2, filterFn2);

  const {
    TblContainer3,
    TblHead3,
    TblPagination3,
    recordsAfterPagingAndSorting3,
  } = useTableFijo3(records3, headCells3, filterFn3);

  /* const Calcular = () => {

      let totalsv = 0.00;
      let tootal = 0.00;
      let punitario = props.ordencompra.punitario;
      let cantidad = props.ordencompra.cantidad;
      let iva = props.ordencompra.iva;

      totalsv = punitario * cantidad;
      tootal = totalsv * iva / 100;
      setIdvista(tootal);

  } */

  const handleUnidadSolicitante = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescrip.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarUnidadSolicitante(event.target.value);
      }
    }
  };

  const seleccionarUnidadSolicitante = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcoordinacion > 0) {
            txtCodigo.current.value = response.data.idcoordinacion;
            txtDescrip.current.value =
              response.data.nombre.trim() +
              "(" +
              response.data.nombredir.trim() +
              ")";
            //alert(txtDescrip.current.value)
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.target.name === "cantpresupuesto") {
    } else if (event.target.name === "cantcarta") {
    } /*else if (event.target.name === 'idciudad') {

            setValuest({ ...valuest, [event.target.name]: event.target.value });

        } */
    /* if (event.target.name === 'razonsocial' || event.target.name === 'direccion' || event.target.name === 'correoe' || event.target.name === 'apellidos' || event.target.name === 'nombres' || event.target.name === 'actprincipal' || event.target.name === 'oficinaregistro' || event.target.name === 'direccion' || event.target.name === 'rif' || event.target.name === 'correoepri' || event.target.name === 'correoesec') {
        event.target.value = event.target.value.toUpperCase();
    }
    setValues({ ...values, [event.target.name]: event.target.value }); */
  };

  const tipoOrdenHandler = (e) => {
    if (
      (e.target.id =
        "radioCompra" ||
        e.target.id === "radioServicio" ||
        e.target.id === "radioProyecto")
    ) {
      if (radioCompra.current.checked) {
        setTipoProv(2);
        setTipoMensajes("Datos que Soportan la Orden de Compra");
      } else if (radioServicio.current.checked) {
        setTipoProv(2);
        setTipoMensajes("Datos que Soportan la Orden de Servicio");
      } /* else if (txtProyecto.current.checked) {
                setTipoProv(0);
                setTipoMensajes("Datos que Soportan el Proyecto");
            }  */
      if (operacion === 1) {
        seleccionarUltimoId(espiritu === 0 ? "idordencompra"
          : radioCompra.current.checked
            ? "idordencompra"
            : radioServicio.current.checked
              ? "idordenservicio"
              : "idordencompra",
        );
      }
    }
  };

  const onCheck = (event) => {
    //event.preventDefault();
    if ((event.target.name = "presupuestos")) {
      if (txtPresu.current.checked) {
        setVisibleF("visible");
      } else {
        setVisibleF("collapse");
        txtCantPresu.current.value = "";
      }
    }

    if ((event.target.name = "cartaexc")) {
      if (txtCartaEx.current.checked) {
        setVisibleG("visible");
      } else {
        setVisibleG("collapse");
        txtCantiCarta.current.value = "";
      }
    }
    /* if (event.target.id = "radioPrecompromisoSi" || event.target.id === "radioPrecompromisoNo") {
        if (txtPrecompromisoSi.current.checked) {
            setVisibleR(1)
        } else if (txtPrecompromisoNo.current.checked) {
            setVisibleR(0)
        }
    } */
  };

  const handleInputMontoChange = (event) => {
    //setActiveIndex(1);
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
          event.target.value = '0,00'
      } */
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputRetencion") {
          txtRtislr.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputCappago") {
          txtCapp.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputCapsub") {
          txtCaps.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const Actualizar = (body) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/actualizarordencompra`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          /* props.onHideCancela()
        props.onHideRenderizar() */

          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Registro " +
                txtIdc.current.value +
                " fue Creado Correctamente.",
              icono: "informacion",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Registro " +
                txtIdc.current.value +
                " fue Modificado Correctamente.",
              icono: "informacion",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Registro " +
                txtIdc.current.value +
                " fue Anulado Correctamente.",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const catalogoCord = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const catalogoProve = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const cerrarModal = (e) => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (operacionP === 3) {
      let idprodu = records[itemSelectP].idproducto;
      let data = [...records.filter((it) => it.idproducto !== idprodu)];
      var totmonto = 0.0;
      var totiva = 0.0;
      var totdescu = 0.0;
      for (let i = 0; i < data.length; i++) {
        totmonto = parseFloat(totmonto) + parseFloat(data[i].totalsiniva);
        totiva = parseFloat(totiva) + parseFloat(data[i].montoiva);
        totdescu = parseFloat(totdescu) + parseFloat(data[i].descuento);
      }
      totmonto =
        Math.round(parseFloat(totmonto) * Math.pow(10, 4)) / Math.pow(10, 4);
      totiva =
        Math.round(parseFloat(totiva) * Math.pow(10, 4)) / Math.pow(10, 4);
      totdescu =
        Math.round(parseFloat(totdescu) * Math.pow(10, 4)) / Math.pow(10, 4);
      //setTotal(totmonto + totiva - totdescu);
      setTotal(
        Math.round((totmonto + totiva) * Math.pow(10, 2)) / Math.pow(10, 2),
      );
      setTotalIva(totiva);
      setTotalSinIva(totmonto);
      setTotaldescuento(totdescu);
      setRecords(data);
      setOperacionP(0);
      if (data.length > 0) {
        setItemSelectP(0);
        setProducto(data[0]);
      } else {
        setItemSelectP(-1);
        setProducto();
      }
    } else if (operacionF === 3) {
      let numfactura = records2[itemSelectF].numfactura;
      let data = [...records2.filter((it) => it.numfactura !== numfactura)];
      var totfactu = 0.0;
      for (let i = 0; i < data.length; i++) {
        totfactu = parseFloat(totfactu) + parseFloat(data[i].total);
      }
      totfactu =
        Math.round(parseFloat(totfactu) * Math.pow(10, 4)) / Math.pow(10, 4);
      setTotalFactu(totfactu);
      setRecords2(data);
      setOperacionF(0);
      if (data.length > 0) {
        setItemSelectF(0);
        setFactura(data[0]);
      } else {
        setItemSelectF(-1);
        //setFactura([]);
      }
    } else if (operacionC === 3) {
      let idcuenta = records3[itemSelectC].idcuenta;
      let data = [...records3.filter((it) => it.idcuenta !== idcuenta)];
      var totcue = 0.0;
      for (let i = 0; i < data.length; i++) {
        totcue = parseFloat(totcue) + parseFloat(data[i].monto);
      }
      totcue =
        Math.round(parseFloat(totcue) * Math.pow(10, 4)) / Math.pow(10, 4);
      setTotalCuenta(totcue);
      setRecords3(data);
      setOperacionC(0);
      if (data.length > 0) {
        setItemSelectC(0);
        setDisponibilidad(data[0].disponible);
        setPresupusto(data[0].montoinicial);
      } else {
        setItemSelectC(-1);
        setDisponibilidad(0.0);
        setPresupusto(0.0);
      }
    }
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtIdc.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtIdc.current.focus();
    } else if (txtFechaC.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha de la Orden de Compra no es valida.",
        icono: "informacion",
      });
      sigue = false;
      txtFechaC.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El concepto no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Ingresar la Unidad Solicitante.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtIdProv.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del proveedor no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtIdProv.current.focus();
    } else if (txtNomProv.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El nombre del proveedor no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtNomProv.current.focus();
    } else if (total === 0.0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe agregar productos a la Solicitud de compra/servicios.",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue === true) {
      let datosorden = [];
      let datoscue = [];

      datosorden.push({
        proce: 0,
        observ: txtObservaciones.current.value,
        concep: txtConcepto.current.value,
        escre: radioContado.current.checked,
        numcon: 1,
        idprove: txtIdProv.current.value,
        moniva: totalIva,
        moncomp: totalSinIva + totaldescuento,
        motiv: "reverso",
        idcoord: txtCodigo.current.value,
        requis: txtRequisicion.current.checked ? 1 : 0,
        invit: txtIdc.current.checked ? 1 : 0,
        inform: txtRqInforme.current.checked ? 1 : 0,
        presup: txtPresu.current.checked ? 1 : 0,
        cantpres: txtPresu.current.checked
          ? parseInt(txtCantPresu.current.value)
          : 0,
        cart: txtCartaEx.current.checked ? 1 : 0,
        cantcart: txtCartaEx.current.checked
          ? parseInt(txtCantiCarta.current.value)
          : 0,
        proy: 0,
        descproy: null,
        tentre: txtTiempoEntrega.current.value,
        obs: txtLugarEntrega.current.value,
        idresp: txtIdProv.current.value,
        idprecompro: 0,
      });

      var datacue = [...records3];
      for (let i = 0; i < datacue.length; i++) {
        datoscue.push({
          m_nIdCta: datacue[i].idcuenta,
          m_cAux: datacue[i].auxiliar,
          m_nMonto: datacue[i].monto,
          m_nMontoPre: datacue[i].montoprecompromiso,
          m_nIdCatPro: datacue[i].idcat,
          m_nIdPuc: datacue[i].idpuc,
        });
      }
      let body = {
        operacion: operacion,
        idordenc: txtIdc.current.value,
        tipo: props.servicio ? 1 : 0,
        idefi: idefiscal,
        idusuario: idusuario,
        fecha: txtFechaC.current.value,
        //espiritu: espiritu,
        datosordenc: datosorden,
        detalleordenc: records,
        datoscuenta: datoscue,
        datosfactu: records2,
      };

      Actualizar(body);
    }
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setActivate(false);
    setOperacionPer(0);
    setCoordinacion({
      idcoordinacion: "",
      nombre: "",
    });
    setValuest({
      idestado: "",
      idmunicipio: "",
      idciudad: "",
    });
    setValues({
      idordencompra: "",
      fecha: "",
      observaciones: "",
      tipo: "",
      concepto: "",
      escredito: "",
      numcontrol: "",
      monto: "",
      montoiva: "",
      idproveedor: "",
      idcordinacion: "",
      idusuario_crea: "",
      fecha_crea: "",
      fecha_reverso: "",
      idusuario_reversa: "",
      hora_crea: "",
      horareverso: "",
      reversado: "",
      motivo: "",
      reqrequisicion: "",
      reqinvitacion: "",
      reqinforme: "",
      cantpresupuesto: "",
      cantcarta: "",
      reqcarta: "",
      proyecto: "",
      descripcionproyecto: "",
      tentrega: "",
      observacion: "",
      idordenservicio: "",
      reqpresupuesto: "",
      iddatosresponsables: "",
      idprecompromiso: "",
      idprecompromisoaso: "",
      aprobada: "",
      unidades: "",
      iddatalcalde: "",
      iddatadmini: "",
    });
    setTabIndex(0);
    setOperacion(0);
    setVisibleF("collapse");
    setVisibleG("collapse");
    setVisibleR(0);
    // setTipoMensajes();
    setTipoMensajes("Datos que Soportan la Orden de Compra");
    setMensaje1();
    setMsg("");
    setRecords([]);
    setRecords2([]);
    setRecords3([]);
    setFactura([]);
    setDeshabilitado(false);
    setTotal(0.0);
    setTotalIva(0.0);
    setTotalSinIva(0.0);
    setTotaldescuento(0.0);
    setTabs({
      tab1: "tab-pane fade show active",
      tab2: "tab-pane",
      tab3: "tab-pane",
      tab4: "tab-pane",
      tab5: "tab-pane",
      btn: 1,
    });
    setTabIndex(0);
    setItemSelectF(0);
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setHabilitadoNR(false);
    blanquear();
    props.onHideCancela();
  };

  const handleAceptaCatalogoProv = (idprov, idcdprov, nomb) => {
    setMostrar3(false);
    txtIdProv.current.value = idprov;
    txtCedRif.current.value = idcdprov;
    txtNomProv.current.value = nomb;
    txtIdc.current.focus();
  };

  const handleAceptaCatalogoCord = (idcor, nom) => {
    setMostrar4(false);
    /* setCoordinacion({ ...values, idcoordinacion: valor.idcor, nombre: valor.nom }) */
    txtCodigo.current.value = idcor;
    txtDescrip.current.value = nom;
    //alert(txtDescrip.current.value)
    txtConcepto.current.focus();
  };

  const handleCloseCatalogoProv = () => {
    setMostrar3(false);
  };

  const handleCloseCatalogoCord = () => {
    setMostrar4(false);
  };

  const handlerClickTab = (index, lastIndex, event) => {
    //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
    if (operacion === 1 && index === 6) {
      setTabIndex(0);
    } else {
      setTabIndex(index);
    }
    /* if (txtProyecto.current.checked === false) {
        if (index === 2) {
            setTabIndex(0);
        } else {
            setTabIndex(index);
        }
    } */
  };

  const gestionProducto = (ope, index) => (event) => {
    event.preventDefault();
    //blanquearCampos();
    setOperacionP(ope);
    if (ope === 1) {
      if (txtNomProv.current.value.trim() !== "") {
        setMostrarAgregar(true);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe primero seleccionar un Proveedor.",
          icono: "informacion",
        });
        txtNomProv.current.focus();
      }
    } else if (ope === 2 && itemSelectP >= 0) {
      //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Se eliminaran todas las retenciones de esta factura\nEsta seguro de Editar el registro?', icono: 'confirmacion' });
      setMostrarAgregar(true);
    } else if (ope === 3 && itemSelectP >= 0) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Está seguro de eliminar el producto?",
        icono: "confirmacion",
      });
      //setMostrar5(true);
      //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
      //setMostrarAgregar(true)
    } else if (ope === 4 && itemSelectP >= 0) {
      //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Está seguro de eliminar el registro?', icono: 'confirmacion' });
      //setMostrar5(true);
      //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
      setMostrarAgregar(true);
    }
  };

  const gestionFactura = (ope, index) => (event) => {
    event.preventDefault();
    //blanquearCampos();
    setOperacionF(ope);
    if (ope === 1) {
      if (records.length > 0) {
        setMostrarAgregarF(true);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe agregar productos a la Solicitud de compra/servicios.",
          icono: "informacion",
        });
        setTabs({
          tab1: "tab-pane fade show active",
          tab2: "tab-pane",
          tab3: "tab-pane",
          tab4: "tab-pane",
          tab5: "tab-pane",
          btn: 1,
        });
        setTabIndex(0);
      }
    } else if (ope === 2) {
      //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Se eliminaran todas las retenciones de esta factura\nEsta seguro de Editar el registro?', icono: 'confirmacion' });
      if (itemSelectF >= 0) {
        setMostrarAgregarF(true);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar una Factura.",
          icono: "informacion",
        });
      }

    } else if (ope === 3 && itemSelectF >= 0) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Está seguro de eliminar la factura?",
        icono: "confirmacion",
      });
      //setMostrar5(true);
      //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
      //setMostrarAgregar(true)
    } else if (ope === 4 && itemSelectF >= 0) {
      //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Está seguro de eliminar el registro?', icono: 'confirmacion' });
      //setMostrar5(true);
      //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
      setMostrarAgregarF(true);
    }
  };

  const gestionCuenta = (ope, index) => (event) => {
    event.preventDefault();
    setOperacionC(ope);
    if (ope === 1) {
      if (records.length > 0) {
        setMostrarAgregarC(true);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe agregar productos a la Solicitud de compra/servicios.",
          icono: "informacion",
        });
        setTabs({
          tab1: "tab-pane fade show active",
          tab2: "tab-pane",
          tab3: "tab-pane",
          tab4: "tab-pane",
          tab5: "tab-pane",
          btn: 1,
        });
        setTabIndex(0);
      }
    } else if (ope === 3 && itemSelectC >= 0) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Está seguro de eliminar la factura?",
        icono: "confirmacion",
      });
      //setMostrar5(true);
      //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
      //setMostrarAgregar(true)
    }
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        txtIdProv.current.value.trim() !== "" &&
        txtNomProv.current.value.trim() === ""
      ) {
        txtIdProv.current.value = "";
        /* txtCedRif.current.value = "";
        txtNomProv.current.value = ""; */
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Proveedor No Existe.",
          icono: "informacion",
        });
      } else {
        if (event.which === 13) {
          txtRequisicion.current.focus();
        }
      }
    }
  };

  const selectProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtCedRif.current.value = "";
    txtNomProv.current.value = "";
    setRecords2([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      }
    }
  };

  const seleccionarProveedor = (codigo) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    setActivate(true);
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            if (response.data.status.trim() === "0" && operacion === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Proveedor no se encuentra activo.",
                icono: "informacion",
              });
              txtIdProv.current.value = "";
              txtCedRif.current.value = "";
              txtNomProv.current.value = "";
              txtIdProv.current.focus();
              setActivate(false);
              return;
            }
            txtIdProv.current.value = response.data.idproveedor;
            txtCedRif.current.value = response.data.rif;
            txtNomProv.current.value = response.data.razonsocial;
            txtIdProv.current.focus();
            setProveExento(response.data.exentoiva);
          } else {
            /*setTitulo('Información');
            setMsg('Proveedor No Existe.');
            setMostrar(true);*/
            /* setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "Proveedor No Existe.",
                icono: "informacion",
            });
            txtIdProv.current.value = "";
            txtCedRif.current.value = "";
            txtNomProv.current.value = ""; */
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarUltimoId = (nomid) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/ultimocodigo?idefiscal=${idefiscal}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data === "") {
            txtIdc.current.value = 1;
          } else {
            if (espiritu === 0) {
              txtIdc.current.value = parseInt(response.data.idordencompra) + 1;
            } else if (radioCompra.current.checked) {
              txtIdc.current.value = parseInt(response.data.idordencompra) + 1;
            } else if (radioServicio.current.checked) {
              txtIdc.current.value =
                parseInt(response.data.idordenservicio) + 1;
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarFilaProducto = (index) => (e) => {
    e.preventDefault();
    setItemSelectP(index);

    var datos = [];

    datos.push({
      idproducto: recordsAfterPagingAndSorting()[index].idproducto,
      descripcion: recordsAfterPagingAndSorting()[index].descripcion,
      unidadmedida: recordsAfterPagingAndSorting()[index].unidadmedida,
      punitario: recordsAfterPagingAndSorting()[index].punitario,
      cantidad: recordsAfterPagingAndSorting()[index].cantidad,
      descuento: recordsAfterPagingAndSorting()[index].descuento,
      iva: recordsAfterPagingAndSorting()[index].iva,
      garantia: recordsAfterPagingAndSorting()[index].garantia,
    });
    setProducto(datos[0]);
  };

  const seleccionarFilaFactura = (index) => (e) => {
    e.preventDefault();
    setItemSelectF(index);

    var datos = [];

    datos.push({
      idfacturaxorden: recordsAfterPagingAndSorting2()[index].idfacturaxorden,
      numoperacion: recordsAfterPagingAndSorting2()[index].numoperacion,
      numfactura: recordsAfterPagingAndSorting2()[index].numfactura,
      numcontrol: recordsAfterPagingAndSorting2()[index].numcontrol,
      fecfactura: recordsAfterPagingAndSorting2()[index].fecfactura,
      subtotal: recordsAfterPagingAndSorting2()[index].subtotal,
      otros: recordsAfterPagingAndSorting2()[index].otros,
      ajustes: recordsAfterPagingAndSorting2()[index].ajustes,
      exento: recordsAfterPagingAndSorting2()[index].exento,
      baseimpo: recordsAfterPagingAndSorting2()[index].baseimpo,
      iva: recordsAfterPagingAndSorting2()[index].iva,
      total: recordsAfterPagingAndSorting2()[index].total,
    });

    setFactura(datos[0]);
  };

  const seleccionarFilaCuenta = (index) => (e) => {
    e.preventDefault();
    setItemSelectC(index);
    setDisponibilidad(recordsAfterPagingAndSorting3()[index].disponible);
    setPresupusto(recordsAfterPagingAndSorting3()[index].montoinicial);
  };

  const handleAceptarProduto = (datos) => {
    setMostrarAgregar(false);

    let data = [...records];
    let index = -1;
    if (operacionP === 1) {
      //for (let i = 0; i < datos.length; i++) {
      data.push({
        idproducto: datos.idproducto,
        descripcion: datos.descripcion,
        unidadMedida: datos.unidadmedida,
        punitario: datos.precioUnitario
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        cantidad: datos.cantidad.trim().replace(/\./g, "").replace(",", "."),
        descuento: datos.descuento.trim().replace(/\./g, "").replace(",", "."),
        iva: datos.porcentajeIva.trim().replace(/\./g, "").replace(",", "."),
        montoiva: datos.montoiva.trim().replace(/\./g, "").replace(",", "."),
        totalsiniva: datos.totalsiniva
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        garantia: datos.garantia,
      });

      //}
      index = data.length - 1;
      setItemSelectP(data.length - 1);
    } else if (operacionP === 2) {
      data[itemSelectP].idproducto = datos.idproducto;
      data[itemSelectP].descripcion = datos.descripcion;
      data[itemSelectP].punitario = datos.precioUnitario
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].cantidad = datos.cantidad
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].descuento = datos.descuento
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].iva = datos.porcentajeIva
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].montoiva = datos.montoiva
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].totalsiniva = datos.totalsiniva
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      data[itemSelectP].garantia = datos.garantia;

      index = itemSelectP;
    }
    var totmonto = 0.0;
    var totiva = 0.0;
    var totdescu = 0.0;
    let tota = 0.0;
    for (let i = 0; i < data.length; i++) {
      totmonto = parseFloat(totmonto) + parseFloat(data[i].totalsiniva);
      totiva = parseFloat(totiva) + parseFloat(data[i].montoiva);
      totdescu = parseFloat(totdescu) + parseFloat(data[i].descuento);
    }
    totmonto =
      Math.round(parseFloat(totmonto) * Math.pow(10, 4)) / Math.pow(10, 4);
    totiva = Math.round(parseFloat(totiva) * Math.pow(10, 4)) / Math.pow(10, 4);
    totdescu =
      Math.round(parseFloat(totdescu) * Math.pow(10, 4)) / Math.pow(10, 4);
    //setTotal(totmonto + totiva - totdescu);
    tota = totmonto + totiva;
    tota = Math.round(parseFloat(tota) * Math.pow(10, 2)) / Math.pow(10, 2);
    setTotal(tota);
    setTotalIva(totiva);
    setTotalSinIva(totmonto - totdescu);
    setTotaldescuento(totdescu);
    setProducto(data[index]);
    setRecords(data);
    setOperacionP(0);
  };

  const handleAceptarFactura = (datos) => {
    setMostrarAgregarF(false);

    let data = [...records2];
    let index = -1;
    if (operacionF === 1) {
      //for (let i = 0; i < datos.length; i++) {

      data.push({
        idfacturaxorden: datos[0].idfacturaxorden,
        numoperacion: datos[0].numoperacion,
        numfactura: datos[0].numfactura,
        numcontrol: datos[0].numcontrol,
        fecfactura: datos[0].fecfactura,
        subtotal: datos[0].subtotal,
        otros: datos[0].otros,
        ajustes: datos[0].ajustes,
        exento: datos[0].exento,
        baseimpo: datos[0].baseimpo,
        iva: datos[0].iva,
        total: datos[0].total,
      });

      //}
      index = data.length - 1;
      setItemSelectF(data.length - 1);
    } else if (operacionF === 2) {
      data[itemSelectF].idfacturaxorden = datos[0].idfacturaxorden;
      data[itemSelectF].numoperacion = datos[0].numoperacion;
      data[itemSelectF].numfactura = datos[0].numfactura;
      data[itemSelectF].numcontrol = datos[0].numcontrol;
      data[itemSelectF].fecfactura = datos[0].fecfactura;
      data[itemSelectF].subtotal = datos[0].subtotal;
      data[itemSelectF].otros = datos[0].otros;
      data[itemSelectF].ajustes = datos[0].ajustes;
      data[itemSelectF].exento = datos[0].exento;
      data[itemSelectF].baseimpo = datos[0].baseimpo;
      data[itemSelectF].iva = datos[0].iva;
      data[itemSelectF].total = datos[0].total;
      index = itemSelectF;
    }
    var totFact = 0.0;
    for (let i = 0; i < data.length; i++) {
      totFact = parseFloat(totFact) + parseFloat(data[i].total);
    }
    totFact =
      Math.round(parseFloat(totFact) * Math.pow(10, 4)) / Math.pow(10, 4);
    setTotalFactu(totFact);
    //txtTotalFacturas.current.value = formatMoneda(totFact.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    setFactura(data[index]);
    setRecords2(data);
    //props.data(data, index, operacionFactu, datos[0].numfactura);
  };

  const handleAceptarCuenta = (datos) => {
    console.log(datos);
    setMostrarAgregarC(false);
    let index = -1;
    for (let i = 0; i < records3.length; i++) {
      for (let z = 0; z < datos.length; z++) {
        if (records3[i].idcuenta === datos[z].idcuenta) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Tipo de Compromiso",
            icono: "informacion",
          });
        }
      }
    }
    let data = [...records3];

    for (let i = 0; i < datos.length; i++) {
      data.push({
        uno: datos[i].uno,
        dos: datos[i].dos,
        tres: datos[i].tres,
        cuatro: datos[i].cuatro,
        cinco: datos[i].cinco,
        seis: datos[i].seis,
        siete: datos[i].siete,
        ocho: datos[i].ocho,
        nueve: datos[i].nueve,
        auxiliar: datos[i].auxiliar,
        descripcion: datos[i].descripcion,
        montoinicial: datos[i].montoinicial,
        montoprecompromiso: datos[i].monto,
        disponible: datos[i].disponible,
        monto: datos[i].monto,
        idcuenta: datos[i].idcuenta,
        idcat: datos[i].idcat,
        idpuc: datos[i].idpuc,
        descripcionaux: datos[i].descripcionaux,
        descripcat: "",
        descrippuc: "",
        cuenta: `${datos[i].uno}-${datos[i].dos}-${datos[i].tres}-${datos[i].cuatro}-${datos[i].cinco}-${datos[i].seis}-${datos[i].siete}-${datos[i].ocho}-${datos[i].nueve}`,
        //idmovimiento: data[i].idmovimiento,
      });
    }

    let total = 0.0;
    let montoiva = 0.0;

    for (let e = 0; e < data.length; e++) {
      total = parseFloat(total) + parseFloat(data[e].monto);
    }

    //montoiva = total * iva / 100;
    index = data.length - 1;
    setItemSelectC(index);
    setTotalCuenta(total);
    setDisponibilidad(data[index].disponible);
    setPresupusto(data[index].montoinicial);
    setRecords3(data);
  };

  const onTabs = (op) => (e) => {
    e.preventDefault();
    if (op === 1) {
      setTabs({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
        tab5: "tab-pane",
        btn: 1,
      });
    } else if (op === 2) {
      setTabs({
        tab1: "tab-pane",
        tab2: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
        tab5: "tab-pane",
        btn: 2,
      });
    } else if (op === 3) {
      setTabs({
        tab1: "tab-pane",
        tab2: "tab-pane",
        tab3: "tab-pane fade show active",
        tab4: "tab-pane",
        tab5: "tab-pane",
        btn: 3,
      });
    } else if (op === 4) {
      setTabs({
        tab1: "tab-pane",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane fade show active",
        tab5: "tab-pane",
        btn: 4,
      });
    } else if (op === 5) {
      setTabs({
        tab1: "tab-pane",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
        tab5: "tab-pane fade show active",
        btn: 5,
      });
    }
  };
  const imprimir = (e) => {

    e.preventDefault();
    let obj = JSON.parse(localStorage.getItem("post"));
    let sql3 = obj.login;

    let sql =
      (!props.servicio
        ? "S.IdOrdenCompra = " + props.ordencompra.idordencompra
        : "S.IdOrdenServicio = " + props.ordencompra.idordenservicio) +
      " AND S.IDEFISCAL = " +
      idEfi +
      " AND D.IDEFISCAL = " +
      idEfi;

    let sql1 =
      "mov.IdOrdenCompra = " +
      (!props.servicio ? props.ordencompra.idordencompra : props.ordencompra.idordenservicio) +
      " AND mov.IDEFISCAL = " +
      idEfi +
      " AND cta.IDEFISCAL = " +
      idEfi +
      " AND tipo = " +
      (!props.servicio ? 0 : 1);

    window.open(
      `${op.reportes}/comprasyalmacen?reporte=${espiritu === 0 ? 'ForOrdenCompraPrePaez' : 'ForOrdenCompraPre'}&CONDICION=${sql}&CONDICION1=${sql1}&ELABORADO=${sql3}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrosp="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        setTabIndex(0);
        if (props.operacion !== 1) {
          setRecords2(props.facturas);
          setItemSelectF(-1);
          //setRecords(props.detalle)
          setValues(props.ordencompra);
          setCoordinacion(props.cord);
          txtIdc.current.value =
            props.ordencompra.tipo === 0
              ? props.ordencompra.idordencompra
              : props.ordencompra.idordenservicio;
          txtFechaC.current.value = moment
            .utc(props.ordencompra.fecha)
            .format("YYYY-MM-DD");
          txtCodigo.current.value = props.cord.idcoordinacion;
          txtDescrip.current.value =
            props.cord.nombre.trim() + "(" + props.cord.nombredir.trim() + ")";
          txtConcepto.current.value =
            props.ordencompra.concepto === null
              ? ""
              : props.ordencompra.concepto.trim();
          txtObservaciones.current.value =
            props.ordencompra.observaciones === null
              ? ""
              : props.ordencompra.observaciones.trim();
          txtLugarEntrega.current.value =
            props.ordencompra.observacion === null
              ? ""
              : props.ordencompra.observacion.trim();
          txtTiempoEntrega.current.value =
            props.ordencompra.tentrega === null
              ? ""
              : props.ordencompra.tentrega.trim();
          txtIdProv.current.value = props.ordencompra.idproveedor;
          txtCedRif.current.value = props.proveedor.rif;
          txtNomProv.current.value = props.proveedor.razonsocial;
          txtRequisicion.current.checked = props.ordencompra.reqrequisicion;
          txtRqInforme.current.checked = props.ordencompra.reqinforme;
          txtInvitacion.current.checked = props.ordencompra.reqinvitacion;
          txtPresu.current.checked = props.ordencompra.reqpresupuesto;
          if (props.ordencompra.reqpresupuesto === 1) {
            txtCantPresu.current.value = props.ordencompra.cantpresupuesto;
          }
          txtCartaEx.current.checked = props.ordencompra.reqcarta;
          if (props.ordencompra.reqcarta === 1) {
            txtCantiCarta.current.value = props.ordencompra.cantcarta;
          }

          var totmonto = 0.0;
          var totiva = 0.0;
          var totdescu = 0.0;
          var data = props.detalle;
          for (let i = 0; i < data.length; i++) {
            data[i].totalsiniva =
              parseFloat(data[i].punitario) * parseFloat(data[i].cantidad) -
              parseFloat(data[i].descuento);
            data[i].montoiva =
              ((parseFloat(data[i].punitario) * parseFloat(data[i].cantidad) -
                parseFloat(data[i].descuento)) *
                parseFloat(data[i].iva)) /
              100;
            totmonto = parseFloat(totmonto) + parseFloat(data[i].totalsiniva);
            totiva = parseFloat(totiva) + Math.round(parseFloat(data[i].montoiva) * Math.pow(10, 2)) / Math.pow(10, 2);
            //totiva = Math.round(parseFloat(totiva) * Math.pow(10, 4)) / Math.pow(10, 4);
            totdescu = parseFloat(totdescu) + parseFloat(data[i].descuento);
          }
          totmonto =
            Math.round(parseFloat(totmonto) * Math.pow(10, 2)) /
            Math.pow(10, 2);
          totiva =
            Math.round(parseFloat(totiva) * Math.pow(10, 2)) / Math.pow(10, 2);
          totdescu =
            Math.round(parseFloat(totdescu) * Math.pow(10, 2)) /
            Math.pow(10, 2);
          //setTotal(totmonto + totiva - totdescu);
          setTotal(
            Math.round((totmonto + totiva) * Math.pow(10, 2)) / Math.pow(10, 2),
          );
          setTotalIva(totiva);
          setTotalSinIva(totmonto);
          setTotaldescuento(totdescu);
          setRecords(data);

          if (props.ordencompra.tipo === 0) {
            if (props.ordencompra.proyecto === 0) {
              radioCompra.current.checked = true;
              //txtProyecto.current.checked = false;
              radioServicio.current.checked = false;
              setTipoMensajes("Datos que Soportan la Orden de Compra");
            } else {
              //txtProyecto.current.checked = true;
              radioCompra.current.checked = false;
              radioServicio.current.checked = false;
              setTipoProv(2);
              setTipoMensajes("Datos que Soportan el Proyecto");
            }
          } else {
            radioCompra.current.checked = false;
            radioServicio.current.checked = true;
            //txtProyecto.current.checked = false;
            setTipoProv(2);
            setTipoMensajes("Datos que Soportan la Orden de Servicio");
          }
          if (props.ordencompra.escredito) {
            radioContado.current.checked = true;
            radioCredito.current.checked = false;
          } else {
            radioContado.current.checked = false;
            radioCredito.current.checked = true;
          }
          if (parseInt(props.ordencompra.reversado) === 1) {
            setMensaje1(
              <p className="text-danger fw-bold">
                ¡ La Solicitud Se Encuentra Anulada !
              </p>,
            );
            setDeshabilitado(true);
          } else if (
            (props.operacion === 3 || props.operacion === 2) &&
            props.ordencompra.status === 2
          ) {
            setMensaje1(
              <p className="text-warning fw-bold">
                ¡ La Solicitud de Compra ya fue Comprometida !
              </p>,
            );
            setDeshabilitado(true);
          } else if (props.ordencompra.status === 2 && props.operacion === 4) {
            setMensaje1(
              <p className="text-warning fw-bold">
                ¡ La Solicitud de Compra ya fue Comprometida !
              </p>,
            );
            //setDeshabilitado(true);
          } else if (props.ordencompra.status === 8 && props.operacion === 4) {
            setMensaje1(
              <p className="text-info fw-bold">
                ¡ La Solicitud de Compra/Servicios esta en Administración por
                Aprobar !
              </p>,
            );
            //setDeshabilitado(true);
          } else if (props.ordencompra.status === 1 && props.operacion !== 4) {
            setMensaje1(
              <p className="text-success fw-bold">
                ¡ La Solicitud de Compra ya fue Aprobada !
              </p>,
            );
            setDeshabilitado(true);
          } else if (props.ordencompra.status === 1 && props.operacion === 4) {
            setMensaje1(
              <p className="text-success fw-bold">
                ¡ La Solicitud de Compra ya fue Aprobada !
              </p>,
            );
          } else if (props.ordencompra.status === 0 && props.operacion === 4) {
            setMensaje1(
              <p className="text-info fw-bold">
                ¡ Solicitud de Compra por Aprobar !
              </p>,
            );
          }

          if (props.ordencompra.reqpresupuesto === 1) {
            setVisibleF("visible");
          } else {
            setVisibleF("collapse");
          }

          if (props.ordencompra.reqcarta === 1) {
            setVisibleG("visible");
          } else {
            setVisibleG("collapse");
          }
          var datos = [];
          data = props.detallecuenta;
          for (let i = 0; i < data.length; i++) {
            datos.push({
              uno: data[i].cuenta.substring(0, 2),
              dos: data[i].cuenta.substring(2, 4),
              tres: data[i].cuenta.substring(4, 6),
              cuatro: data[i].cuenta.substring(6, 8),
              cinco: data[i].cuenta.substring(8, 10),
              seis: data[i].cuenta.substring(10, 13),
              siete: data[i].cuenta.substring(13, 15),
              ocho: data[i].cuenta.substring(15, 17),
              nueve: data[i].cuenta.substring(17, 19),
              auxiliar: data[i].auxiliar,
              descripcion: data[i].descripcion,
              descripcat: data[i].descripcat,
              descrippuc: data[i].descrippuc,
              monto: data[i].monto,
              montoinicial: data[i].montoinicial,
              montoprecompromiso: data[i].monto,
              disponible: data[i].disponibilidad,
              descripcionaux: data[i].descripcionaux,
              idcat: data[i].idcategoriaprogramatica,
              idpuc: data[i].idpuc,
              idcuenta: data[i].idcuenta,
              cuenta: `${data[i].cuenta.substring(0, 2)}-${data[i].cuenta.substring(2, 4)}-${data[i].cuenta.substring(4, 6)}-${data[i].cuenta.substring(6, 8)}-${data[i].cuenta.substring(8, 10)}-${data[i].cuenta.substring(10, 13)}-${data[i].cuenta.substring(13, 15)}-${data[i].cuenta.substring(15, 17)}-${data[i].cuenta.substring(17, 19)}`
            });
          }
          setItemSelectC(0);
          setRecords3(datos);
        } else {
          txtFechaC.current.value = moment
            .utc(fechaSistema)
            .format("YYYY-MM-DD");
          if (props.servicio) {
            radioServicio.current.checked = true;
            radioCompra.current.checked = false;
            //txtProyecto.current.checked = false;
            setTipoMensajes("Datos que Soportan la Orden de Servicio");
          } else {
            radioCompra.current.checked = true;
            radioServicio.current.checked = false;
            //txtProyecto.current.checked = false;
            setTipoMensajes("Datos que Soportan la Orden de Compra");
          }
          seleccionarUltimoId(espiritu === 0 ? "idordencompra"
            : radioCompra.current.checked
              ? "idordencompra"
              : radioServicio.current.checked
                ? "idordenservicio"
                : "idordencompra",
          );
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <div className="fw-bold">
          {operacion === 1
            ? "Solicitud de Compra."
            : operacion === 2
              ? "Modificar Solicitud de Compra."
              : operacion === 3
                ? "Eliminar Solicitud de Compra."
                : "Consultar Solicitud de Compra."}
        </div>
        <button
          ref={btnCancela}
          className="text-light m-0 p-0 bg-transparent border-0"
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <CatalogoProveedor
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatProv={handleCloseCatalogoProv}
        onHideAceptaCatProv={handleAceptaCatalogoProv}
        tipo={tipoProv}
      />
      <CatalogoCoordinacion
        titulo={titulo}
        mensaje={msg}
        show={mostrar4}
        onHideCancelaCatCord={handleCloseCatalogoCord}
        onHideAceptaCatCord={handleAceptaCatalogoCord}
      />
      <Modal.Body
        className="border-table m-1 rounded"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />

        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={handleCloseNo}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="row mx-auto px-0 col-m-12 ">
          <div className="input-group input-group-sm px-0 mb-1 col-md-2">
            <span className="input-group-text " id="inputGroup-sizing-sm">
              Código:{" "}
            </span>
            <input
              type="text"
              disabled={operacion !== 1 ? true : false}
              ref={txtIdc}
              className="form-control text-uppercase"
              name="idordencompra"
              id="inputCodigo"
            />
          </div>

          <div className="col-md-7"></div>

          <div className="input-group input-group-sm px-0 mb-1 col-md-3">
            <label className="input-group-text" id="inputGroup-sizing-sm">
              Fecha:
            </label>
            <input
              type="date"
              className="form-control text-uppercase"
              disabled={operacion === 4 || operacion === 3 ? true : false}
              ref={txtFechaC}
              name="fecha"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <fieldset className="col-md-3 border-azul rounded py-2 row mx-auto mb-1">
            <legend
              className="float-none m-0 w-auto text-uppercase"
              style={{
                fontSize: "0.85rem",
              }}
            >
              Tipo de Solicitud
            </legend>
            <div className="col-md-12 row m-auto">
              <div className="form-check col my-auto">
                <input
                  type="radio"
                  className="form-check-input my-auto"
                  id="radioCompra"
                  ref={radioCompra}
                  disabled={true}
                  value="1"
                  name="tipo"
                  defaultChecked
                  onChange={tipoOrdenHandler}
                />
                <label
                  className="form-check-label my-auto"

                >
                  Compra
                </label>
              </div>

              <div className="form-check col my-auto">
                <input
                  type="radio"
                  className="form-check-input my-auto"
                  id="radioServicio"
                  ref={radioServicio}
                  disabled={true}
                  value="0"
                  name="tipo"
                  onChange={tipoOrdenHandler}
                />
                <label
                  className="form-check-label my-auto"

                >
                  Servicio
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset className="col-md-9 border-azul rounded py-2 row mx-auto mb-1">
            <legend
              className="float-none m-0 w-auto text-uppercase"
              style={{
                fontSize: "0.85rem",
              }}
            >
              Unidad Solicitante
            </legend>

            <div className="input-group input-group-sm col-md-12 py-0 mb-0 px-0 mb-2">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Codigo:
              </span>
              <input
                type="text"
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                ref={txtCodigo}
                className="form-control form-control-sm col-md-2"
                name="idcoordinacion"
                onChange={handleUnidadSolicitante}
                id="inputNombreRespon"
              />
              <button
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                onClick={catalogoCord}
                className="btn btn-success btn-sm"
              >
                <i disabled={deshabilitado} className="fas fa-search"></i>
              </button>

              <span className="input-group-text" id="inputGroup-sizing-sm">
                Descripción:
              </span>
              <input
                type="text"
                disabled={true}
                ref={txtDescrip}
                className="form-control form-control-sm"
                name="descrip"
                id="inputDescrip"
              />
            </div>
          </fieldset>
          <fieldset className="col-md-12 border-azul rounded py-2 row mx-auto mb-1">
            <div className="input-group input-group-sm mb-1 col-md-6 px-0">
              <span className="input-group-text ">Concepto: </span>
              <textarea
                type="textarea"
                style={{ height: 40 }}
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                ref={txtConcepto}
                name="observacion"
                className="form-control text-uppercase"
                id="inputDescripcion"
              />
            </div>
            <div className="input-group input-group-sm mb-1 col-md-6 px-0">
              <span className="input-group-text ">Observaciones: </span>
              <textarea
                type="textarea"
                style={{ height: 40 }}
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                ref={txtObservaciones}
                className="form-control text-uppercase"
                name="observaciones"
                id="inputCodigo"
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-6 px-0">
              <span className="input-group-text ">Lugar de Entrega: </span>
              <textarea
                type="textarea"
                style={{ height: 40 }}
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                ref={txtLugarEntrega}
                className="form-control text-uppercase"
                name="lentrega"
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-6 px-0">
              <span className="input-group-text ">Tiempo de Entrega: </span>
              <textarea
                type="textarea"
                style={{ height: 40 }}
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                ref={txtTiempoEntrega}
                className="form-control form-control-sm text-uppercase"
                name="tentrega"
                id="inputNombreRespon"
              />
            </div>
          </fieldset>

          <fieldset className="row col-md-9 border-azul rounded mx-auto mb-1">
            <legend
              className="float-none m-0 w-auto text-uppercase"
              style={{
                fontSize: "0.85rem",
              }}
            >
              Beneficiario/Proveedor
            </legend>
            <div className="col-12 px-0 mb-1">
              <div className="row col-md-12 mx-auto py-0 px-0">
                {/* Código del proveedor */}

                <div className="input-group input-group-sm mb-1 px-0 col-md-2">
                  <span className="input-group-text">Código:</span>
                  <input
                    type="text"
                    ref={txtIdProv}
                    disabled={
                      operacion === 4 || operacion === 3 || deshabilitado
                    }
                    className="form-control"
                    defaultValue={props.proveedor?.idproveedor}
                    id="inputCedula"
                    onChange={selectProveedor}
                    autoComplete="off"
                    onKeyUp={handleProveedor}
                    onBlur={handleProveedor}
                  />
                  <button
                    disabled={
                      operacion === 4 || operacion === 3 || deshabilitado
                    }
                    onClick={catalogoProve}
                    className="btn btn-info btn-sm"
                    type="button"
                    title="Buscar proveedor"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                {/* RIF */}
                <div className="input-group input-group-sm mb-1 px-0 col-md-3">
                  <span className="input-group-text">Rif:</span>
                  <input
                    type="text"
                    disabled
                    ref={txtCedRif}
                    className="form-control"
                    id="inputNombreRespon"
                    readOnly
                  />
                </div>

                {/* Nombre completo */}

                <div className="input-group input-group-sm mb-1 px-0 col-md-7">
                  <span className="input-group-text">Nombre:</span>
                  <input
                    type="text"
                    disabled
                    ref={txtNomProv}
                    className="form-control"
                    id="inputApellidosRespon"
                    readOnly
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset className="row col-md-3 border-azul rounded mx-auto mb-1">
            <legend
              className="float-none m-0 w-auto text-uppercase"
              style={{
                fontSize: "0.85rem",
              }}
            >
              Forma de Pago
            </legend>
            <div className="col-md-12 row m-auto">
              <div className="form-check col my-auto">
                <input
                  type="radio"
                  ref={radioContado}
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  className="form-check-input my-auto"
                  id="customControlValidation7"
                  name="escredito"
                  defaultChecked
                  required
                />

                <label
                  className="form-check-label my-auto"

                >
                  Contado
                </label>
              </div>

              <div className="form-check col my-auto">
                <input
                  type="radio"
                  ref={radioCredito}
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  className="form-check-input my-auto"
                  id="customControlValidation8"
                  name="escredito"
                  required
                />
                <label
                  className="form-check-label my-auto"

                >
                  Credito
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset className="row col-md-12 border-azul rounded mx-auto mb-2">
            <legend
              className="float-none m-0 w-auto text-uppercase"
              style={{
                fontSize: "0.85rem",
              }}
            >
              {tipoMensajes}
            </legend>
            <div className="d-flex justify-content-between col-md-12 mx-auto">
              <div className="d-flex align-items-center my-auto">
                <label className="d-flex align-items-center my-2">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    ref={txtPresu}
                    disabled={
                      operacion === 3 || operacion === 4 || deshabilitado
                    }
                    defaultChecked={props.ordencompra?.reqpresupuesto === 1}
                    onChange={onCheck}
                    name="presupuestos"
                  />
                  <span>Presupuestos</span>
                </label>
                <input
                  type="text"
                  disabled={operacion === 3 || operacion === 4 || deshabilitado}
                  ref={txtCantPresu}
                  className="form-control form-control-sm text-end ml-1"
                  style={{ width: "70px", visibility: visibleF }}
                  name="cantpresupuesto"
                  defaultValue={"0"}
                  onChange={onChange}
                  placeholder="Cant."
                />
              </div>

              <div className="d-flex align-items-center my-auto">
                <label className="d-flex align-items-center my-2">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    ref={txtCartaEx}
                    disabled={
                      operacion === 3 || operacion === 4 || deshabilitado
                    }
                    defaultChecked={props.ordencompra?.reqcarta === 1}
                    onChange={onCheck}
                    name="cartaexc"
                  />
                  <span>Carta/Excusa</span>
                </label>
                <input
                  type="text"
                  disabled={operacion === 3 || operacion === 4 || deshabilitado}
                  ref={txtCantiCarta}
                  className="form-control form-control-sm text-end ml-1"
                  style={{ width: "80px", visibility: visibleG }}
                  name="cantcarta"
                  defaultValue={"0"}
                  onChange={onChange}
                  placeholder="Cant."
                />
              </div>

              <div className="d-flex align-items-center my-auto">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    ref={txtRequisicion}
                    disabled={
                      operacion === 3 || operacion === 4 || deshabilitado
                    }
                    defaultChecked={props.ordencompra?.reqrequisicion === 1}
                    name="requisicion"
                  />
                  <span>Requisición</span>
                </label>
              </div>

              <div className="d-flex align-items-center my-auto">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    ref={txtRqInforme}
                    disabled={
                      operacion === 3 || operacion === 4 || deshabilitado
                    }
                    defaultChecked={props.ordencompra?.reqinforme === 1}
                    name="reqinforme"
                  />
                  <span>Informe de Recomendación</span>
                </label>
              </div>

              <div className="d-flex align-items-center my-auto">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    ref={txtInvitacion}
                    disabled={
                      operacion === 3 || operacion === 4 || deshabilitado
                    }
                    defaultChecked={props.ordencompra?.reqinvitacion === 1}
                    name="reqinvitacion"
                  />
                  <span>Invitación</span>
                </label>
              </div>
            </div>
          </fieldset>

          <ul className="nav col-12" id="ex-with-icons" role="tablist">
            <div className="col-10 d-flex justify-content-between pl-0 ml-0">
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(1)}
                  className={`${tabs.btn === 1 ? "active" : ""} nav-link bg-blue-100 text-light rounded`}
                  id="datosTributarios"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#tributarios"
                  role="tab"
                  aria-controls="tributarios"
                  aria-selected="true"
                >
                  Datos de Solicitud
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(2)}
                  className={`${tabs.btn === 2 ? "active" : ""} nav-link bg-blue-200 text-light rounded`}
                  id="datosTributarios2"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#tributarios2"
                  role="tab"
                  aria-controls="tributarios2"
                  aria-selected="false"
                >
                  Facturas
                </a>
              </li>

              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(5)}
                  className={`${tabs.btn === 5 ? "active" : ""} nav-link bg-blue-200 text-light rounded`}
                  id="datosTributarios5"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#tributarios5"
                  role="tab"
                  aria-controls="tributarios5"
                  aria-selected="false"
                >
                  Codificación
                </a>
              </li>
              {mensaje1 !== "" ? (
                <div className="container text-center col ml-auto">
                  <h3> {mensaje1} </h3>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-1 d-flex justify-content-between pr-0 mr-2">
              {tabs ? (
                tabs.btn === 5 ? (
                  <>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="btn btn-sm rounded-circle btn-primary btn-sm col-6 m-1"
                      onClick={gestionCuenta(1, "")}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="btn btn-sm rounded-circle btn-danger btn-sm col-6 m-1"
                      onClick={gestionCuenta(3, itemSelectC)}
                    >
                      <i className="fa fa-trash-alt"></i>
                    </button>
                  </>
                ) : tabs.btn === 2 ? (
                  <>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="btn btn-sm rounded-circle btn-primary btn-sm col-6 m-1"
                      onClick={gestionFactura(1, "")}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="btn btn-sm rounded-circle btn-warning btn-sm col-6 m-1"
                      onClick={gestionFactura(2, itemSelectF)}
                    >
                      <i className="fa fa-edit"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="btn btn-sm rounded-circle btn-danger btn-sm col-6 m-1"
                      onClick={gestionFactura(3, itemSelectF)}
                    >
                      <i className="fa fa-trash-alt"></i>
                    </button>
                  </>
                ) : tabs.btn === 1 ? (
                  <>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={gestionProducto(4, itemSelectP)}
                      className="btn btn-info rounded-circle btn-sm col-md-6 m-1"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={gestionProducto(1, "")}
                      className="btn btn-primary rounded-circle btn-sm col-md-6 m-1"
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={gestionProducto(2, itemSelectP)}
                      className="btn btn-warning rounded-circle btn-sm col-md-6 m-1"
                    >
                      <i className="fa fa-edit"></i>
                    </button>
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={gestionProducto(3, itemSelectP)}
                      className="btn btn-danger rounded-circle btn-sm col-md-6 m-1"
                    >
                      <i className="fa fa-trash-alt"></i>
                    </button>
                  </>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </ul>
          <div className="tab-content py-1 px-0" id="myTabContent">
            <div
              className={tabs.tab1}
              id="tributarios"
              role="tabpanel"
              aria-labelledby="tab1"
            >
              <div className="row col-md-12 mx-auto px-0 ">
                <div className="col-md-12 px-0">
                  <TblContainer
                    container={{
                      height: 150,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />

                    <tbody>
                      {records &&
                        records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <tr
                            key={`${index}-P`}
                            style={{
                              padding: "0",
                              height: "auto",
                              cursor: "pointer",
                              background:
                                itemSelectP === index
                                  ? "lightskyblue"
                                  : "white",
                            }}
                            onClick={seleccionarFilaProducto(index)}
                          >
                            <td
                              style={{ fontSize: "14px", textAlign: "center", width: '50px' }}
                            >
                              {item.idproducto}
                            </td>
                            <td style={{ fontSize: "14px", textAlign: "right", width: '100px' }}>
                              {formatMoneda(
                                item.cantidad.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td style={{ fontSize: "14px", textAlign: "left", width: 'auto' }}>
                              {item.descripcion}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right", width: '100px' }}
                            >
                              {formatMoneda(
                                item.punitario.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right", width: '100px' }}
                            >
                              {formatMoneda(
                                item.iva.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right", width: '100px' }}
                            >
                              {formatMoneda(
                                (
                                  ((item.punitario * item.cantidad -
                                    item.descuento) *
                                    item.iva) /
                                  100
                                )
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right", width: '100px' }}
                            >
                              {formatMoneda(
                                item.descuento.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right", width: '100px' }}
                            >
                              {formatMoneda(
                                (
                                  item.punitario * item.cantidad -
                                  item.descuento
                                )
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "center", width: '100px' }}
                            >
                              {formatMoneda(
                                (
                                  ((item.punitario * item.cantidad -
                                    item.descuento) *
                                    item.iva) /
                                  100 +
                                  item.punitario * item.cantidad -
                                  item.descuento
                                )
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>
                </div>
              </div>
            </div>
            <div
              className={tabs.tab2}
              id="tributarios2"
              role="tabpanel"
              aria-labelledby="tab2"
            >
              <div className="row col-md-12 mx-auto px-0">
                <div className="col-md-12 px-0">
                  <TblContainer2
                    container={{
                      height: 150,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead2 />

                    <tbody>
                      {records2 &&
                        records2 &&
                        recordsAfterPagingAndSorting2().map((item, index) => (
                          <tr
                            key={`${index}-${item.numfactura}`}
                            style={{
                              padding: "0",
                              height: "25px",
                              cursor: "pointer",
                              background:
                                itemSelectF === index
                                  ? "lightskyblue"
                                  : "white",
                            }}
                            onClick={seleccionarFilaFactura(index)}
                          >
                            <td
                              style={{ fontSize: "14px", textAlign: "center" }}
                            >
                              {item.numfactura}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "center" }}
                            >
                              {item.numcontrol}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "center" }}
                            >
                              {moment.utc(item.fecfactura).format("DD/MM/YYYY")}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.subtotal.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.otros.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.ajustes.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.exento.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.baseimpo.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.iva.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                            <td
                              style={{ fontSize: "14px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.total.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer2>
                </div>
              </div>
            </div>
            <div
              className={tabs.tab3}
              id="tributarios3"
              role="tabpanel"
              aria-labelledby="tab3"
            >
              <div className="container row">
                <div className="input-group input-group-sm mb-3 col-md-12">
                  <span className="input-group-text ">
                    Descripción del Proyecto:{" "}
                  </span>

                  <textarea
                    style={{ height: 40 }}
                    type="text"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDescrp}
                    name="descripcionproyecto"
                    className="form-control text-uppercase"
                    id="inputDescripcion"
                  />
                </div>
              </div>
            </div>
            <div
              className={tabs.tab4}
              id="tributarios4"
              role="tabpanel"
              aria-labelledby="tab4"
            ></div>
            <div
              className={tabs.tab5}
              id="tributarios5"
              role="tabpanel"
              aria-labelledby="tab5"
            >
              <div className="row col-md-12 mx-auto px-0">
                <div className="col-md-12 px-0">
                  <TblContainer3
                    container={{
                      height: 150,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead3 />

                    <tbody>
                      {records3 &&
                        records3 &&
                        recordsAfterPagingAndSorting3().map((item, index) => (
                          <tr
                            key={`${index}-C`}
                            style={{
                              padding: "0",
                              height: "30px",
                              cursor: "pointer",
                              background:
                                itemSelectC === index
                                  ? "lightskyblue"
                                  : "white",
                            }}
                            onClick={seleccionarFilaCuenta(index)}
                          >
                            <td
                              className="align-middle"
                              style={{
                                fontSize: "14px",
                                textAlign: "center",
                                width: "auto",
                              }}
                            >
                              {item.cuenta}
                            </td>

                            <td
                              className="align-middle"
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                width: "auto",
                              }}
                            >
                              {item.descripcionaux.trim() !== ""
                                ? item.descripcionaux.trim()
                                : item.descripcion.trim()}{" "}
                            </td>
                            <td
                              className="align-middle"
                              style={{
                                fontSize: "14px",
                                textAlign: "right",
                                width: "150px",
                              }}
                            >
                              {formatMoneda(
                                item.monto
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}{" "}
                            </td>
                            <td
                              className="align-middle"
                              style={{
                                fontSize: "14px",
                                textAlign: "right",
                                width: "150px",
                              }}
                            >
                              {formatMoneda(
                                item.montoprecompromiso
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}{" "}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer3>
                  <table
                    className="table table-sm border-table "
                    style={{ fontSize: "12px", borderTop: 0 }}
                  >
                    <thead className="thead">
                      <tr className="">
                        <th scope="col" className="col-md-4">
                          Presupuesto: &nbsp;
                          {formatMoneda(
                            presupuesto
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </th>
                        <th scope="col" className="col-md-4">
                          Disponibilidad: &nbsp;
                          {formatMoneda(
                            disponibilidad
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </th>
                        <th scope="col" className="col-md-4">
                          Total Compromiso Bs: &nbsp;
                          {formatMoneda(
                            totalCuenta
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="container col-md-12">
            <table className="table table-sm " style={{ fontSize: "13px" }}>
              <thead className="thead">
                <tr className="">
                  <th scope="col">
                    SubTotal: &nbsp;
                    {formatMoneda(
                      (totalSinIva + totaldescuento)
                        .toString()
                        .replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </th>
                  <th scope="col">
                    Descuento: &nbsp;
                    {formatMoneda(
                      totaldescuento.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </th>
                  <th scope="col">
                    Total IVA: &nbsp;
                    {formatMoneda(
                      totalIva.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </th>
                  <th scope="col">
                    Total: &nbsp;
                    {formatMoneda(
                      total.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </th>
                </tr>
              </thead>
            </table>
          </div>

          <ActualizarProductoCompra
            show={mostrarAgregar}
            producto={{ descripcion: "" }}
            onHideCancela={() => setMostrarAgregar(false)}
            onHideAcepta={handleAceptarProduto}
            operacion={operacionP}
            productoSeleccionado={producto}
            productos={records}
            servicio={props.servicio}
            exento={proveExento}
          />
          <ModalAgregarFactuOC
            show={mostrarAgregarF}
            operacion={operacionF}
            onHideAcepta={handleAceptarFactura}
            onHideCancela={() => setMostrarAgregarF(false)}
            facturas={records2}
            facturasel={factura}
            totalfactu={totalFactu}
            montoorden={total}
          />
          <AgregarCuentasGastos
            show={mostrarAgregarC}
            operacion={operacionC}
            onDatos={handleAceptarCuenta}
            onHideCancela={() => setMostrarAgregarC(false)}
            esaumento={false}
            cuentas={records3}
            montocompro={total}
            total={totalCuenta}
          />
          <div className="col-md-12 row mx-auto py-0 d-flex justify-content-end">
            <button
              onClick={imprimir}
              disabled={operacion === 4 ? false : true}
              className={
                permiso.toString().substring(3, 4) === "1"
                  ? "btn btn-sm btn-primary rounded-pill col-md-2 ml-2"
                  : "btn btn-sm btn-secondary rounded-pill col-md-2 ml-2"
              }
            >
              <i className="fa fa-print"></i>
            </button>
            <button
              ref={btnAcepta}
              disabled={operacion === 4 ? true : deshabilitado}
              onClick={onChangeValidar}
              className="btn btn-success btn-sm rounded-pill fw-bold col-md-2 ml-2"
            >
              <i className="fas fa-check-circle"> Aceptar</i>
            </button>
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-sm btn-danger rounded-pill fw-bold col-md-2 ml-2"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
